import Model from 'src/app/core/models/model';

export default class UOMMasterModel extends Model {
  name?: string;
  description?: string;
  othername?: string;
  system_uom: boolean;
  uomadded: boolean;

  constructor() {
    super();
  }
}
